import Document from '@tiptap/extension-document';

const CustomDocument = Document.extend({
    content: 'paragraph+',
});

export default CustomDocument;
